// @flow
import React from 'react';
import { illustrationColor } from './designSystem.js';

export const DisabilityIcon = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 32 32"
    fill="none"
    style={{ marginRight: 20 }}
  >
    <path
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
      fill={illustrationColor.cloudburst}
    />
    <path
      d="M8.43784 17.6636H7.2797C6.97963 17.6636 6.73682 17.9064 6.73682 18.2065V24.721C6.73682 25.0211 6.97963 25.2639 7.2797 25.2639H8.43784C9.33591 25.2639 10.0665 24.5333 10.0665 23.6353V19.2922C10.0665 18.3942 9.33595 17.6636 8.43784 17.6636Z"
      fill="white"
    />
    <path
      d="M25.1042 18.7167C25.039 18.6082 24.9522 18.5213 24.8545 18.4453C24.4548 18.0956 23.7813 18.1286 23.3888 18.5539L20.924 21.3986L20.848 21.4854C20.5441 21.822 20.1097 22.0066 19.6537 22.0066H15.441C15.1369 22.0066 14.8981 21.7677 14.8981 21.4637C14.8981 21.1597 15.1369 20.9209 15.441 20.9209H18.7526C19.3497 20.9209 19.8383 20.4323 19.8383 19.8351V19.8242C19.8275 19.2271 19.3497 18.7493 18.7526 18.7493H16.7873C16.4617 18.7493 16.1128 18.6298 15.8319 18.391C14.5073 17.2292 12.5746 17.1532 11.1522 18.1413V24.8187C12.2271 25.1119 13.3346 25.2639 14.4529 25.2639H19.2954C20.4897 25.2639 21.619 24.6993 22.3356 23.7438L24.9414 20.2694C25.3216 19.7703 25.3502 19.0859 25.1042 18.7167Z"
      fill="white"
    />
    <path
      d="M21.2937 7.78297C20.6916 7.10625 19.8569 6.73358 18.9434 6.73358C17.9238 6.73358 17.04 7.2157 16.3875 8.12777C16.3385 8.19614 16.2928 8.26454 16.2499 8.33222C16.207 8.26451 16.1612 8.19614 16.1123 8.12777C15.4598 7.2157 14.576 6.73358 13.5563 6.73358C12.6429 6.73358 11.8082 7.10625 11.2061 7.78293C10.6347 8.42513 10.3199 9.28364 10.3199 10.2003C10.3199 11.1965 10.7065 12.1158 11.5364 13.0933C12.2606 13.9462 13.2992 14.8229 14.5019 15.838C14.9463 16.2131 15.4059 16.601 15.8943 17.0243C15.9963 17.1127 16.1231 17.1569 16.2499 17.1569C16.3766 17.1569 16.5034 17.1127 16.6054 17.0243C17.0937 16.6011 17.5533 16.2132 17.9977 15.8382C18.7701 15.1862 19.4372 14.6232 20.016 14.0771C21.1399 13.0167 22.1798 11.8131 22.1798 10.2004C22.1798 9.28367 21.8651 8.42516 21.2937 7.78297Z"
      fill="white"
    />
  </svg>
);

export const EnglishLanguageLearnerIcon = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 32 32"
    fill="none"
    style={{ marginRight: 20 }}
  >
    <path
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
      fill={illustrationColor.cloudburst}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0887 6H23.7793C24.0757 6 24.3159 6.24025 24.3159 6.5366V23.7794C24.3159 24.0758 24.0757 24.316 23.7793 24.316H22.4888C22.2779 24.316 22.0865 24.1925 21.9997 24.0003L21.2763 22.3983C21.164 22.1498 20.9143 21.9919 20.6427 21.997C19.69 22.0136 18.5198 22.0313 17.9228 22.0194C17.2804 22.0067 16.906 21.734 16.705 21.5074C16.4266 21.1936 16.2988 20.7648 16.3453 20.3001C16.3722 20.0308 16.2995 19.939 16.1545 19.7563L16.1542 19.756C16.0447 19.6178 15.9084 19.446 15.8427 19.2013C15.7428 18.8295 15.8887 18.4243 16.2144 18.1689C16.229 18.1575 16.2441 18.1468 16.2598 18.1369L17.338 17.4587L15.7265 16.8473C15.7128 16.8421 15.6993 16.8363 15.686 16.83C15.3011 16.6466 15.088 16.2259 15.1678 15.807L15.3763 14.7128C15.3975 14.6012 15.373 14.4888 15.3071 14.3963C15.2413 14.3037 15.1432 14.2437 15.0308 14.2271L13.97 14.0712C13.6764 14.028 13.4247 13.8424 13.2967 13.5747C13.1687 13.3072 13.1822 12.9948 13.3328 12.7392L15.3547 9.30715C15.6623 8.7851 15.7836 8.1674 15.6964 7.56781L15.5577 6.61387C15.5353 6.45969 15.5809 6.30339 15.6829 6.18556C15.7848 6.06772 15.9329 6 16.0887 6ZM8.80682 13.7369C9.01638 13.5274 9.01638 13.1876 8.80682 12.9781C8.59729 12.7685 8.25751 12.7685 8.04795 12.9781C5.31751 15.7085 5.31751 20.1514 8.04795 22.8818C8.15273 22.9866 8.29007 23.039 8.42737 23.039C8.56466 23.039 8.70203 22.9866 8.80678 22.8818C9.01634 22.6723 9.01634 22.3325 8.80678 22.1229C6.49481 19.8109 6.49481 16.049 8.80682 13.7369ZM10.0663 14.5883C10.2759 14.3787 10.6157 14.3787 10.8252 14.5883C11.0347 14.7978 11.0347 15.1376 10.8251 15.3471C9.40097 16.7713 9.40097 19.0886 10.8251 20.5127C11.0347 20.7223 11.0347 21.0621 10.8251 21.2716C10.7204 21.3764 10.583 21.4288 10.4457 21.4288C10.3084 21.4288 10.1711 21.3764 10.0663 21.2716C8.2237 19.429 8.2237 16.4309 10.0663 14.5883ZM12.0793 16.2435C12.2888 16.034 12.6286 16.034 12.8381 16.2435C13.0477 16.4531 13.0477 16.7928 12.8381 17.0024C12.3267 17.5138 12.3267 18.346 12.8381 18.8575C13.0477 19.0671 13.0477 19.4068 12.8381 19.6164C12.7334 19.7211 12.596 19.7735 12.4587 19.7735C12.3214 19.7735 12.1841 19.7211 12.0793 19.6164C11.1494 18.6865 11.1494 17.1734 12.0793 16.2435Z"
      fill="white"
    />
  </svg>
);

export const InstructionalSupportInformationIcon = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: 20 }}
  >
    <path
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
      fill="#21374D"
    />
    <rect
      x="0.5"
      y="-0.5"
      width="2"
      height="4"
      rx="1"
      transform="matrix(-1 0 0 1 27 19.25)"
      fill="white"
      stroke="white"
    />
    <path
      d="M24.9155 14.8436C25.8117 14.5053 26 13.9313 26 13.5098C26 13.0883 25.8117 12.5143 24.9151 12.176L17.2436 9.27689C16.7711 9.09815 16.1517 9 15.5 9C14.8483 9 14.2289 9.09815 13.7564 9.27689L6.08486 12.1755C5.18826 12.5143 5 13.0877 5 13.5098C5 13.9313 5.18826 14.5053 6.08486 14.8441L8.95391 15.9285L14.283 17.6308C15.0746 17.8837 15.9254 17.8837 16.7171 17.6309L22.0461 15.929L24.9155 14.8436Z"
      fill="white"
    />
    <path d="M25.5 13.5V18.5" stroke="white" />
    <path
      d="M22.0923 18.2071C22.0923 17.7856 22.0923 16.5001 22.0923 16.5001L9 16.5L9.0002 18.2066L9.00008 22.0133C9.00008 22.7386 9.37456 23.7604 11.1579 24.5089C12.3392 25.0048 13.8978 25.2781 15.5462 25.2781C17.1946 25.2781 18.7532 25.0048 19.9344 24.5089C21.7178 23.7604 22.0923 22.7386 22.0923 22.0133V18.2071ZM9 16.5C9 16.5 21.5648 16.5001 22.0923 16.5001L21.2974 16.8888L21.2925 16.8908L16.9366 18.5367C16.581 18.671 16.074 18.748 15.5466 18.748C15.0191 18.748 14.5122 18.671 14.1566 18.5367L9.80071 16.8908L9.79579 16.8888L9 16.5Z"
      fill="white"
    />
  </svg>
);

export const CommonMisconceptionIcon = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 32 32"
    fill="none"
    style={{ marginRight: 20 }}
  >
    <path
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
      fill="#21374D"
    />
    <rect
      x="19.1261"
      y="20.8939"
      width="2.5"
      height="7.52874"
      rx="1"
      transform="rotate(-45 19.1261 20.8939)"
      fill="white"
    />
    <circle cx="13.6233" cy="13.1233" r="8.12326" fill="white" />
    <path
      d="M11.7879 8.89646C12.0707 8.6914 12.0707 8.35888 11.7879 8.15379C11.5051 7.94874 11.0466 7.94874 10.7637 8.15379C7.07876 10.826 7.07876 15.174 10.7637 17.8462C10.9051 17.9487 11.0905 18 11.2758 18C11.4611 18 11.6465 17.9487 11.7878 17.8462C12.0707 17.6411 12.0707 17.3086 11.7878 17.1035C8.66763 14.8408 8.66763 11.1592 11.7879 8.89646Z"
      fill="#21374D"
    />
  </svg>
);
